/**
 * AI Service - V9.1.5-SHIELDED
 * ARCHITECTURE PROTECTED Edition
 * 
 * Reconfigurado para usar el proxy corporativo /api/ai/anthropic.
 */

export const optimizeAIData = (data: any) => {
    if (!data) return "Sin datos disponibles.";
    if (typeof data === 'string') return data.slice(0, 2000);
    if (Array.isArray(data)) {
        return data.slice(0, 15).map(i => 
            `- ${i.nombre || i.name || 'Indicador'}: ${i.real || 0}/${i.meta || i.meta_anual || 0} (${i.progreso || 0}%)`
        ).join('\n');
    }
    return JSON.stringify(data).slice(0, 1500);
};

/**
 * Función universal para consultar a la IA (Proxy-based)
 */
export const askAI = async (prompt: string, context: string = "") => {
    const cleanContext = optimizeAIData(context);
    const fullPrompt = `${prompt}\n\n[CONTEXTO ESTRATÉGICO]:\n${cleanContext}`.trim();

    try {
        // Mejor práctica: Endpoint relativo para producción y desarrollo (vía Vite Proxy)
        const response = await fetch("/api/ai/anthropic", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                model: "claude-3-5-sonnet-20240620",
                max_tokens: 1500,
                system: "Eres el consultor experto de COPARMEX. Respondes con datos precisos, tono ejecutivo y en español de México.",
                messages: [
                    { role: "user", content: fullPrompt }
                ]
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error?.message || `Gateway AI Error (${response.status})`);
        }

        const data = await response.json();
        return data.content[0].text;
    } catch (err: any) {
        console.error("[AI_SERVICE_ERROR]:", err.message);
        throw new Error("No se pudo conectar con el motor de inteligencia. Verifica el estado del proxy.");
    }
};

export default { askAI, optimizeAIData };
